module.exports = __webpack_public_path__ + "static/assets/ef787238f52fe78e6e12ae2d9d0e1f60.gif";